                                                                               
                                                                              
                                                                                             

class PrinthiaColorPayment {
  form                         = null;
  payment                     = null;
          observer                          = null;
          markers            = [];
          ancestors                = [];
          selection                         = null;
          prepared = false;
          committed = false;
          changed = false;
          messages                ;
          overlay = document.getElementById('vcp-overlay') ;
          slot = document.getElementById('vcp-payment-slot') ;
          status = document.getElementById('vcp-payment-status') ;
          price = document.getElementById('vcp-payment-price') ;
          confirm = document.getElementById('vcp-confirm-btn') ;

  constructor(messages                ) { this.messages = messages; }

  open(form                 , selection                 )          {
    if (this.form) this.close();
    const payment = form.querySelector             ('.shopify-payment-button');
    if (!payment) throw new Error('The product form has no native payment button.');
    this.form = form;
    this.payment = payment;
    this.selection = selection;
    this.prepared = false;
    this.committed = false;
    this.changed = false;
    for (const node of [this.overlay, payment]) {
      const marker = document.createComment('vcp-payment-position');
      node.before(marker);
      this.markers.push(marker);
    }
    for (let parent = form.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
      parent.classList.add('vcp-payment-ancestor');
      this.ancestors.push(parent);
    }
    form.appendChild(this.overlay);
    this.slot.appendChild(payment);
    this.overlay.classList.add('vcp-payment-mode');
    this.confirm.hidden = true;
    this.slot.hidden = false;
    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(form.closest('product-info') || form, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value']
    });
    form.addEventListener('change', this.refresh);
    this.refresh();
    return true;
  }

  prepare(changeMaterial            )       {
    this.prepared = true;
    this.committed = false;
    this.changed = true;
    this.payment .inert = true;
    changeMaterial();
    this.refresh();
  }

  clearSelection()       {
    this.prepared = false;
    this.refresh();
  }

  ready()          {
    if (!this.form || !this.prepared || !this.selection?.matches()) return false;
    const productInfo = this.form.closest                    ('product-info');
    const input = this.form.querySelector                  ('input[name="id"]');
    const add = this.form.querySelector                   ('button[name="add"]');
    if (!input?.value || input.disabled || !add || add.disabled || add.getAttribute('aria-disabled') === 'true' || productInfo?.pendingRequestUrl) return false;
    const data = productInfo?.querySelector('variant-selects [data-selected-variant]');
    if (productInfo) {
      if (!data?.textContent) return false;
      let variant;
      try { variant = JSON.parse(data.textContent); }
      catch (error) { console.error('Invalid native variant data', error); return false; }
      if (!variant?.available || String(variant.id) !== input.value) return false;
    }
    return true;
  }

  refresh = ()       => {
    if (!this.form || !this.payment) return;
    const ready = this.ready();
    const info = this.form.closest                    ('product-info');
    const error = this.form.closest('product-form')?.querySelector             ('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')?.textContent?.trim();
    const text = !this.prepared ? this.messages.choose : ready ? '' : error || (info?.pendingRequestUrl ? this.messages.loading : this.messages.unavailable);
    if (this.status.textContent !== text) this.status.textContent = text;
    this.status.hidden = !text;
    this.payment.hidden = !this.prepared;
    this.payment.inert = !ready;
    this.slot.setAttribute('aria-busy', String(this.prepared && !!info?.pendingRequestUrl));
    const priceNode = info?.querySelector             ('.price--on-sale .price-item--sale, .price:not(.price--on-sale) .price__regular .price-item--regular');
    const price = ready ? priceNode?.textContent?.trim() || '' : '';
    if (this.price.textContent !== price) this.price.textContent = price;
    this.price.hidden = !price;
    if (document.activeElement?.closest('variant-selects')) document.getElementById('vcp-close-btn') .focus({ preventScroll: true });
  };

  commit()       { this.committed = true; this.selection?.remember(); }

  close()       {
    if (!this.form) return;
    const rollback = this.changed && !this.committed ? this.selection?.restore : null;
    this.observer?.disconnect();
    this.form.removeEventListener('change', this.refresh);
    this.payment .hidden = false;
    this.payment .inert = false;
    this.markers[1].replaceWith(this.payment );
    this.markers[0].replaceWith(this.overlay);
    this.ancestors.forEach(node => node.classList.remove('vcp-payment-ancestor'));
    this.overlay.classList.remove('vcp-payment-mode');
    this.slot.hidden = true;
    this.confirm.hidden = false;
    this.form = null;
    this.payment = null;
    this.selection = null;
    this.markers = [];
    this.ancestors = [];
    this.prepared = false;
    rollback?.();
  }
}

(window                                                                   ).PrinthiaColorPayment = PrinthiaColorPayment;
